/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogComponent} from "../../../../platform/base/components/base-dialog.component";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "contact-aigia-info-dialog",
	styleUrls: ["./aigia-info-dialog.component.css"],
	templateUrl: "./aigia-info-dialog.component.html",
})

export class AigiaInfoDialogComponent extends BaseDialogComponent implements OnInit {

	/**
	 * @returns none
	 */
	get content(): any {
		return this.data.content;
	}

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<AigiaInfoDialogComponent>,
		public translate: TranslateService
	) {
		super();
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {

	}

	/**
	 * @returns none
	 */
	public onAccept(): void {
		this.matDialogRef.close(true);
	}

}
